var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import React from "react";
var SvgOther = function SvgOther(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({}, props, {
    width: "1em",
    height: "1em",
    viewBox: "0 0 42 32",
    fill: "currentColor"
  }), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M18.431 28v-8m4.235 0v8m-4.235-4h4.235m-12-4h2.118m2.118 0h-2.118m0 0v8m-8.117-8a2 2 0 012 2v4a2 2 0 01-4 0v-4a2 2 0 012-2zm25.999 0h-4v4m4 4h-4v-4m0 0h2.667m5.333 0h2a2 2 0 000-4h-2v4zm0 0v4m4 0L36 24M24 4v5.333a1.333 1.333 0 001.333 1.334h5.334M24 4h-9.333A2.667 2.667 0 0012 6.667V16M24 4l6.667 6.667m0 0V16",
    stroke: "#089BEE",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
};
export default SvgOther;